import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { ActivatedRoute, RouterModule } from "@angular/router";
import { UserService } from "src/app/features/user/user.service";
import { Router } from "@angular/router";
import { AuthService } from "src/app/core/auth/auth.service";

@Component({
  selector: "app-confirm-email",
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: `./confirm-email.html`,
})
export class ConfirmEmailComponent implements OnInit {
  status: "loading" | "success" | "error" = "loading";

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private authService: AuthService,
  ) {}

  public goToLogin(): void {
    this.authService.logout();
    this.router.navigate(["/login"]);
  }

  public ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get("token");
    const email = this.route.snapshot.queryParamMap.get("email");

    if (!token || !email) {
      this.status = "error";
      return;
    }

    this.userService.confirmEmail(token, email).subscribe({
      next: () => {
        this.status = "success";
        this.authService.logout();
      },
      error: () => {
        this.status = "error";
      },
    });
  }
}
